const config = {
  env: process.env.NODE_ENV,
  baseURI: "https://reqres.in/api",
};

export default config;
